import { createFileRoute } from '@tanstack/react-router';
import SignUpForm from '~/components/Auth/SignUpForm/SignUpForm';

export const Route = createFileRoute('/_public/register')({
  component: SignUpForm,
});
